module.exports = "./img/ce3930b343b5d97c21f54730110d548d.jpg";